import type { ConfigPersist, Persist } from './types'
import { persist as base } from './core'

export type {
    ConfigPersist,
    ConfigSourceTarget,
    ConfigStore,
    Contract,
    Done,
    Fail,
    Finally,
    Persist,
    StorageAdapter,
    StorageAdapterFactory
} from './types'

//
// reexport adapters
//
export type { LocalStorageConfig } from './local'
export type { LogConfig } from './logs'
export type { MemoryConfig } from './memory'
export type { NilConfig } from './nil'
export type { QueryConfig } from './query'
export type { SessionStorageConfig } from './session'
export type { StorageConfig } from './storage'
export { local } from './local'
export { log } from './logs'
export { memory } from './memory'
export { nil } from './nil'
export { query } from './query'
export { session } from './session'
export { storage } from './storage'

//
// reexport tools
//

export { async, either, farcached } from './tools'

/**
 * Creates custom `persist`
 */
export function createPersist(defaults?: ConfigPersist): Persist {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (config: any) =>
        base({
            ...defaults,
            ...config
        })
}

/**
 * Default `persist`
 */
export const persist: Persist = base
